import React, { useEffect, useRef, useState } from 'react';

import elle from '../../../images/lp/googleV2/logoticker_elle.svg';
import cosmo from '../../../images/lp/googleV2/logoticker_cosmo.svg';
import essence from '../../../images/lp/googleV2/logoticker_essence.svg';
import menshealth from '../../../images/lp/googleV2/logoticker_menshealth.svg';
import bazaar from '../../../images/lp/googleV2/logoticker_bazaar.svg';

export function LogoTicker() {
    const logos = [elle, cosmo, essence, menshealth, bazaar];
    const wrapRef = useRef(null);
    const [isScrolling, setIsScrolling] = useState(false);

    useEffect(() => {
        const el = wrapRef.current;
        if (!el) return;

        const check = () => {
            // if content overflows the visible area, enable scrolling
            const track = el.querySelector('.logoticker-track');
            if (!track) return;
            const overflows = track.scrollWidth > el.clientWidth + 2; // small tolerance
            setIsScrolling(Boolean(overflows));
        };

        check();
        const raf = requestAnimationFrame(check);
        const timeoutId = setTimeout(check, 100);

        const onResize = () => check();
        window.addEventListener('resize', onResize);

        return () => {
            cancelAnimationFrame(raf);
            clearTimeout(timeoutId);
            window.removeEventListener('resize', onResize);
        };
    }, []);

    return (
        <section className={`googlelp-logo-ticker py-4 px-0 ${isScrolling ? 'is-scrolling' : ''}`}>
            <div ref={wrapRef} className="logoticker-clip">
                <div className="logoticker-track">
                    {logos.map((src, i) => (
                        <div className="logoticker-item" key={`logo-${i}`}>
                            {src && <img src={src} alt="logo" />}
                        </div>
                    ))}
                    {/* duplicate for seamless loop */}
                    {logos.map((src, i) => (
                        <div className="logoticker-item logoticker-track-mobile" key={`logo-dup-${i}`}>
                            {src && <img src={src} alt="logo" />}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default LogoTicker;
